const SET_LOADED_ADDRESSES = 'addresses/SET_LOADED_ADDRESSES';
const SET_LOADED_VENUES_OF_INTEREST = 'addresses/SET_LOADED_VENUES_OF_INTEREST';
const SET_LOADED_ADDRESSES_OF_INTEREST =
  'addresses/SET_LOADED_ADDRESSES_OF_INTEREST';

const SET_CITY_DATA = 'addresses/SET_CITY_DATA';
const searchAddresses$ = 'addresses/searchAddresses$';
const blurAddresses$ = 'addresses/blurAddresses$';
const fetchAddresses$ = 'addresses/fetchAddresses$';
const loadMoreAddresses$ = 'addresses/loadMoreAddresses$';
const cleanAddress$ = 'addresses/cleanAddress$';

const openAddressModal$ = 'addresses/openAddressModal$';
const openNewAddressModal$ = 'addresses/openNewAddressModal$';
const closeCreateAddress$ = 'addresses/closeCreateAddress$';
const submitCreateAddress$ = 'addresses/submitCreateAddress$';
const submitDeleteAddress$ = 'addresses/submitDeleteAddress$';
const submitCreateAddressForShipment$ =
  'addresses/submitCreateAddressForShipment$';
const changeAddress$ = 'addresses/changeAddress$';
const openEditAddress$ = 'addresses/openEditAddress$';
const zipcodeTyped$ = 'addresses/zipcodeTyped$';
const formChange$ = 'addresses/formChange$';

const searchVenuesOfInterest$ = 'addresses/searchVenuesOfInterest$';
const searchAddressesOfInterest$ = 'addresses/searchAddressesOfInterest$';
const searchStructuredAddress$ = 'addresses/searchStructuredAddress$';
const clearVenuesOfInterest$ = 'addresses/clearVenuesOfInterest';
const clearAddressesOfInterest$ = 'addresses/clearAddressesOfInterest';

export default {
  SET_LOADED_ADDRESSES,
  SET_LOADED_VENUES_OF_INTEREST,
  SET_LOADED_ADDRESSES_OF_INTEREST,

  SET_CITY_DATA,
  searchAddresses$,
  blurAddresses$,
  fetchAddresses$,
  loadMoreAddresses$,
  cleanAddress$,
  openAddressModal$,
  openNewAddressModal$,
  closeCreateAddress$,
  submitCreateAddress$,
  submitDeleteAddress$,
  submitCreateAddressForShipment$,
  changeAddress$,
  openEditAddress$,
  zipcodeTyped$,
  formChange$,

  searchVenuesOfInterest$,
  searchAddressesOfInterest$,
  searchStructuredAddress$,
  clearVenuesOfInterest$,
  clearAddressesOfInterest$,
};
